import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function AddProduct() {
  const [previewImage, setPreviewImage] = useState(null);
  const [designation_name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleImagePreview = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreviewImage(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!designation_name) {
      setError("Please provide name.");
      return;
    }

    setLoading(true);
    setError(null);

    const data = {
      designation_name: designation_name,
    };

    try {
      const response = await fetch(`${BASE_URL}/api/designations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add product: ${response.status} ${errorText}`);
      }

      navigate("/admin/DesignationList");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">

      {/* PAGE TITLE */}
      <h1 className="text-2xl font-brand font-bold text-brandBlue mb-6">
        Add New Designation
      </h1>

      {/* FORM CARD */}
      <div className="bg-white p-6 shadow-md rounded-xl border border-brandLight">

        {/* ERROR MESSAGE */}
        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* PRODUCT NAME */}
          <div className="flex flex-col">
            <label className="font-medium text-brandGrey mb-1">
              Designation Name
            </label>
            <input
              type="text"
              value={designation_name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter designation name"
              className="border border-brandLight rounded-lg px-4 py-2 focus:outline-brandBlue"
              required
            />
          </div>



        </form>

        {/* SUBMIT BUTTON */}
        <div className="mt-6">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-brandBlue hover:bg-brandOrange border-gold text-gold border px-6 py-3 rounded-lg font-medium transition disabled:opacity-50"
          >
            {loading ? "Adding..." : "Add Product"}
          </button>
        </div>

      </div>
    </div>
  );
}
